import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Envelope, Key } from "react-bootstrap-icons";
import axiosAdmin from "../../../../api/apiAdmin";
import { errorToast } from "../../toastAlerts/ToastAlerts";
import { AdminPrimaryContext } from "../../adminContext/AdminContext";
import { useTranslation } from "react-i18next";
import { roleLandingPath } from "../../../../data/adminRoles";

const LoginRihtSide = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    //primary context data and functions
    const { setToken, setUser, setIsAuthorized, isAuthorized, user } = useContext(AdminPrimaryContext);
    // user credentials
    const [loginCredentials, setloginCredentials] = useState({
        email: "",
        password: ""
    })

    //handle login credentials
    const handleLoginCredentials = (e) => {
        setloginCredentials(
            prev => ({ ...prev, [e.target.name]: e.target.value })
        )
    }

    const handleLogin = () => {
        axiosAdmin.post('/login', loginCredentials)
            .then(({ data }) => {
                setUser(data.admin);
                setToken(data.token);
                setIsAuthorized(true);
                // Warehouse operators can't see /admin/users — route them to the
                // packages page they can actually work in.
                navigate(roleLandingPath(data.admin?.role));
            })
            .catch((err) => {
                errorToast(t("admin_login_error"));
            })
    }

    //trigger login on enter click
    function handlePressEnter(event) {
        if (event.key === "Enter") {
            handleLogin();
        }
    }

    //if user is authorized navigate to correct page
    useEffect(() => {
        if (isAuthorized && user?.role) {
            navigate(roleLandingPath(user.role));
        }
    }, [isAuthorized, user?.role])

    return (
        <>
            <div className="w-5/12 max-w-[800px] bg-white  gap-[30px] p-16 max-lg:w-8/12 md:w-10/12
            sm:w-full sm:p-5 md:h-full">
                <div className="mt-4 flex flex-col items-center justify-center">
                    <h1 className="text-2xl font-semibold text-slate-600">{t("admin_welcome_back")}</h1>
                    <p className="text-sm text-slate-400 dark:text-navy-300">{t("admin_please_login")}</p>
                </div>
                <div className="flex flex-col gap-5 mt-6">
                    <div className="pv-2 h-10 flex items-center bg-slate-100 gap-x-1  px-3.5 py-1 rounded-md  group">
                        <Envelope className="text-gray-500 dark:text-white text-[18px]" />
                        <input
                            name="email"
                            onChange={handleLoginCredentials}
                            onKeyDown={handlePressEnter}
                            className="w-full pl-1.5 focus:outline-none bg-slate-100 border-0"
                            type="email"
                            placeholder={t("admin_email_placeholder")} />
                    </div>
                    <div className="pv-2 h-10 flex items-center bg-slate-100 group gap-x-1  px-3.5 py-1 rounded-md ">
                        <Key className="text-gray-500 text-[18px]" />
                        <input
                            name="password"
                            onChange={handleLoginCredentials}
                            onKeyDown={handlePressEnter}
                            className="w-full pl-1.5 focus:outline-none bg-slate-100 border-0"
                            type="text"
                            placeholder={t("admin_password_placeholder")}></input>
                    </div>
                    <div className="mt-6">
                        <button
                            onClick={handleLogin}
                            className="w-full py-2  rounded-md bg-[#443cd3] hover:bg-[#4139c9]
                    text-white text-md text-center ">
                            {t("admin_login_button")}
                        </button>

                    </div>
                </div>
            </div>
  
        </>
    )
}

export default LoginRihtSide;
